import MainNewContact from "../components/new-contact/main-new-contact";

function Contact() {
  return (
    <div>
      <MainNewContact/>
    </div>
  );
}

export default Contact;
